import React from "react";
import memoize from "memoize-weak";
import { uniq } from "lodash";
import AppSettings from "lib/services/AppSettings";
import Select from "./Select";

// Show only PL, EN, CS languages
export const FLAGS = {
  pl: "pl",
  en: "gb",
  // de: "de",
  // fr: "fr",
  // es: "es",
  // it: "it",
  // ru: "ru",
};
export const PRIORITY_LOCALES = ["pl", "en"];
const LOCALE_SEP = "LOCALE_SEP";

const _getLocaleSelectOptions = memoize((locales, localesWithLabels) => {
  const priorityLocales = uniq(
    (locales.includes(I18n.locale) ? [I18n.locale] : []).concat(PRIORITY_LOCALES.filter((l) => locales.includes(l)))
  );

// No other locales
  const otherLocales = [];
  const options =
    priorityLocales.length === 0
      ? locales
      : otherLocales.length === 0
      ? priorityLocales
      : priorityLocales.concat([LOCALE_SEP]).concat(otherLocales);
  return options.map((code, i) => {
    if (code === LOCALE_SEP) {
      return {
        key: i,
        value: LOCALE_SEP,
        text: "---",
        disabled: true,
      };
    } else {
      const localeWithLabel = localesWithLabels && localesWithLabels.find(([c, label]) => c === code);
      const label = localeWithLabel ? localeWithLabel[1] : code;
      return {
        key: i,
        value: code,
        text: label,
        flag: FLAGS[code],
      };
    }
  });
});

export const getLocaleSelectOptions = (locales) =>
  _getLocaleSelectOptions(locales, AppSettings.all_locales_with_labels);

const LocaleSelect = ({ locales, ...rest }) => {
  locales = locales || AppSettings.all_locales || ["pl", "en", "ru"];
  if (["admin_user_locales", "company_locales", "customer_locales"].indexOf(locales) !== -1 && AppSettings[locales]) {
    locales = AppSettings[locales];
  }
  return <Select {...rest} options={getLocaleSelectOptions(locales)} />;
};

export default LocaleSelect;



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/LocaleSelect.jsx